define('models/pages/packs',['require','underscore','models/base/model','models/base/collection','models/filter/index','models/filter-list'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Model = require('models/base/model'),
        Collection = require('models/base/collection'),
        FilterModel = require('models/filter/index'),
        FilterListModel = require('models/filter-list');

    var PacksPageModel = Model.extend({
        urlPath: '/page/packs',
        defaults: {
            sum: 0,
            currency: 'USD',
            amount: 0,
            unit: '',
            trade: '',
            viewCurrency: '',
            baseCurrency: '',
            pricePercent: localStorage.getItem('pricePercent') === 'true',
            hasMarker: false,
            docId: 0,
            avgPrice: 0
        },
        constructor: function(data) {
            this.items = new Collection(data ? data.items : [], { parse: true });
            Model.apply(this, arguments);

            this.filter = new FilterModel({ showSummary: true });
            this.filter.on('filterChanged', _.bind(this.onFilterChanged, this));

            this.filterList = new FilterListModel({ type: 'packs' });
            this.filterList.setFilter(this.filter);

            this.on('change:pricePercent', this.onChangePricePercent);
        },
        load: function() {
            this.filterList.load();

            return Model.prototype.load.apply(this, arguments);
        },
        parse: function(data) {
            var pricePercent = localStorage.getItem('pricePercent') === 'true';

            data.pricePercent = pricePercent;

            // var pricePercent = !!(data.pricePercent || this.get('pricePercent') || this.defaults.pricePercent);
            var item, tSum=0, pSum=0, start, cnt=0, i, l, coef, amount=0, avgPrice=0;
            if (data.items.length) {
                start = data.items[0];
            }
            console.log(data, data.items);
            for (i=0, l=data.items.length; i<l; i++) {
                item = data.items[i];

                if (item.PackNumber !== start.PackNumber || item.PackName !== start.PackName  || item.SellerName !== start.SellerName) {
                    start.rowspan = cnt;

                    cnt = 1;
                    start = item;
                } else {
                    cnt++;
                    item.rowspan = 0;
                }


                item.tPrice = item.RequestPrice;
                item.tSum = item.tPrice * item.Amount;

                item.pPrice = 0;
                item.pSum = 0;

                item.viewPrice = item.tPrice;
                item.viewSum = item.tSum;

                amount += item.Amount;
                tSum += item.tSum;
                pSum += item.SellerPrice * item.Amount;
                avgPrice += item.viewPrice;

                item.selected = false;
            }
            console.log(tSum, pSum, avgPrice, amount);

            coef = pSum ? tSum / pSum : 0;

            if (coef) {
                for (i=0, l=data.items.length; i<l; i++) {
                    item = data.items[i];

                    item.pPrice = item.SellerPrice * coef;
                    item.pSum = item.pPrice * item.Amount;

                    if (pricePercent) {
                        item.viewPrice = item.pPrice;
                        item.viewSum = item.pSum;
                    }
                }
            }

            if (start) {
                start.rowspan = cnt;
            }
            data.amount = amount;
            data.sum = tSum;
            data.currency = item ? item.currency : '';
            data.unit = item ? item.unit || '' : '';

            data.docId = item && item.docId || 0;
            data.avgPrice = amount ? (tSum / amount) : 0;

            this.items.reset(data.items, { silent: true });

            this.filter.setup({
                schema: [
                    {
                        name: 'SellerName',
                        caption: 'Продавец'
                    },
                    {
                        name: 'GoodsType',
                        caption: 'Тип'
                    },
                    {
                        name: 'GoodsName',
                        caption: 'Сорт'
                    },
                    {
                        name: 'Length',
                        caption: 'Длина'
                    }
                ],
                source: data.items
            });

            delete data.items;

            return data;
        },
        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);

            params.tradeId = this.get('tradeId');
            params.inViewCurrency = this.get('inViewCurrency');
            return params;
        },
        onChangePricePercent: function() {
            var p = this.get('pricePercent') ? 'p' : 't';
            var price = p + 'Price';
            var sum = p + 'Sum';

            this.items.each(function(item) {
                item.set('viewSum', item.get(sum));
                item.set('viewPrice', item.get(price));
            });

            localStorage.setItem('pricePercent', this.get('pricePercent') ? 'true' : 'false');
        },
        onFilterChanged: function() {
            var item, start, cnt=0, i, l, sum = 0, amount = 0, price = 0;
            var items = this.filter.get('filtered');

            if (items.length) {
                start = items[0];
            }

            for (i=0, l=items.length; i<l; i++) {
                item = items[i];

                sum += item.tSum;
                amount += item.Amount;

                price += item.viewPrice;

                if (item.PackNumber !== start.PackNumber || item.PackName !== start.PackName  || item.SellerName !== start.SellerName) {
                    start.rowspan = cnt;

                    cnt = 1;
                    start = item;
                } else {
                    cnt++;
                    item.rowspan = 0;
                }
            }

            if (start) {
                start.rowspan = cnt;
            }

            this.set('filterSum', sum);
            this.set('filterAmount', amount);
            this.set('avgPrice', amount ? (sum / amount) : 0);
            this.items.reset(items, { silent: true });
            this.trigger('filterChanged');
        },

        getAttributes: function() {
            return _.extend({ filter: this.filter.getAttributes() }, this.attributes);
        }
    });

    return PacksPageModel;
});
